import React from 'react';
import MetaTags from 'react-meta-tags';
import classNames from 'classnames';
import { Grid, Row, Col } from 'components/Grid';
import { Ads, Banner, Overlay, Overlay2 } from 'components/Ads';

import style from './style.scss';
import notrafficsign from './notrafficsign.png';

export default class NotFound extends React.Component {
  render() {
    return (
      <Ads>
        <MetaTags>
          <title>404 - Page not found | What Car?</title>
        </MetaTags>
        <div className={style.bannerAd}>
          <Banner id="gpt_7294_masthead1" adUnitLevel3="notfound" />
        </div>
        <Grid>
          <Row>
            <Col colXs={12}>
              <div className={style.content}>
                <div className={classNames(style.container, style.mainContent)}>
                  <div className={style.left}>
                    <div>(404 - Page not found)</div>
                    <h1>Oops, looks like you&rsquo;ve reached a dead end</h1>
                    <p>
                      We couldn&rsquo;t find the page you were looking for.
                      Either we&rsquo;ve sent you in the wrong direction, or
                      you&rsquo;re looking for something we don&rsquo;t have.
                    </p>
                    <a href={WHATCAR_URL}>Go to homepage</a>
                  </div>
                  <div className={style.right}>
                    <img src={notrafficsign} alt="" />
                  </div>
                </div>
                <div className={style.contentFooter}>
                  <p>Or, here are some other links to pages on our site</p>
                  <ul>
                    <li>
                      <a href={`${WHATCAR_URL}/reviews`}>New Car Reviews</a>
                    </li>
                    <li>
                      <a href={`${WHATCAR_URL}/new-car-deals`}>New car deals</a>
                    </li>
                    <li>
                      <a href={`${WHATCAR_URL}/used-reviews`}>
                        Used Car Reviews
                      </a>
                    </li>
                    <li>
                      <a href={`${WHATCAR_URL}/used-cars`}>Used car for sale</a>
                    </li>
                    <li>
                      <a href={`${WHATCAR_URL}/latest`}>Latest Stories</a>
                    </li>
                  </ul>
                </div>
              </div>
            </Col>
          </Row>
        </Grid>
        <Overlay id="gpt_7294_overlay" />
        <Overlay2 id="gpt_7294_overlay2" />
      </Ads>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/NotFound/NotFound.js